import { ContactResult, ContactResultType } from "./ContactResult";

/** HTTP request payload shape for creating a contact result.
 * @remarks Intentionally uses legacy API field names (`opportunityId`, `customerId`).
 * Use {@link toContactResultRequest} to map from the domain model.
 */
export interface ContactResultRequest {
  /** @remarks Intentionally using `customerId` to match the backend API. Maps from {@link ContactResult.customerId}. */
  customerId: string;
  /** @remarks Intentionally using `opportunityId` to match the backend API. Maps from {@link ContactResult.leadId}. */
  opportunityId: string;
  type: ContactResultType;
  disqualifyingReasons: Record<string, boolean>;
}

/** Maps a {@link ContactResult} domain model to an HTTP {@link ContactResultRequest} payload. */
export const toContactResultRequest = (contactResult: ContactResult): ContactResultRequest => ({
  customerId: contactResult.customerId,
  opportunityId: contactResult.leadId,
  type: contactResult.type,
  disqualifyingReasons: contactResult.disqualifyingReasons
});
